
<template>
    <div>
        <h5>{{ $t("SIGNERSMONITOR.title") }}</h5>
        <button v-if="!allEnvelopesConcluded && !error.isError"
                type="button"
                class="btn btn-secondary btn-sm float-right button-update"
                v-on:click="updateInfo">
            {{ $t("SIGNERSMONITOR.buttonUpdate") }}
        </button>
        <div class="box">
            <div v-show="load.isLoading" style="text-align: center !important">
                <div class="spinner spinner-md"></div>
                <div>
                    <span class="bold">{{ load.msg }}</span>
                </div>
            </div>
            <div v-show="!load.isLoading">
                <div v-show="error.isError">
                    <h5 class="alert alert-light-warning bold">
                        {{ error.msg }}
                    </h5>
                </div>
                <div v-show="!error.isError">
                    <div v-for="(envelope, index) in envelopes" :key="index" class="envelope-section">
                        <div class="table-responsive" v-show="envelope.signers.length > 0">
                            <table class="form table-striped">
                                <tbody class="form-group">
                                    <tr class="p-2 m-2"
                                        v-for="signer in envelope.signers"
                                        :key="signer.name">
                                        <td>
                                            <span class="bold m-0">
                                                {{ signer.name }}
                                            </span>
                                        </td>
                                        <td>
                                            <p class="m-0">
                                                {{ signer.email }}
                                            </p>
                                        </td>
                                        <td>
                                            <p class="m-0 text-center"
                                               v-bind:class="{
                                                    'badge badge-primary':
                                                        signer.statusId == 4,
                                                    'badge badge-success':
                                                        signer.statusId == 1 ||
                                                        signer.statusId == 2 ||
                                                        signer.statusId == 3 ||
                                                        signer.statusId == 8 ||
                                                        signer.statusId == 9,
                                                    'badge badge-danger':
                                                        signer.statusId == 5 ||
                                                        signer.statusId == 6 ||
                                                        signer.statusId == 7,
                                                }">
                                                {{ signer.status }}
                                            </p>
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"
                                            class="m-0"
                                            style="background-color: white">
                                            {{ $t("SIGNERSMONITOR.titleEnvelope") }}
                                        </td>
                                        <td style="background-color: white">
                                            <span class="m-0"
                                                  v-bind:class="{
                                                    'badge badge-success':
                                                        envelope.statusId ==
                                                            stsEnvelope.Created ||
                                                        envelope.statusId ==
                                                            stsEnvelope.Sent,
                                                    'badge badge-primary':
                                                        envelope.statusId ==
                                                        stsEnvelope.Completed,
                                                    'badge badge-danger':
                                                        envelope.statusId ==
                                                            stsEnvelope.Canceled ||
                                                        envelope.statusId ==
                                                            stsEnvelope.Declined ||
                                                        envelope.statusId ==
                                                            stsEnvelope.NotIdentified,
                                                }">
                                                {{ envelope.status }}
                                            </span>
                                        </td>
                                        <td class="button-align"
                                            style="background-color: white">
                                            <div v-show="!allEnvelopesConcluded"
                                                 class="btn-mobile text-right">
                                                <button type="button"
                                                        class="btn btn-sm btn-info-variant"
                                                        v-on:click="editEnvelope(envelope)">
                                                    <span>{{$t("SIGNERSMONITOR.edit")}}</span>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="m-0 small"
                                            style="background-color: white">
                                            {{ envelope.envelopeUid }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="4"
                                            style="background-color: white">
                                            <hr />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-show="envelope.signers.length == 0">
                            <h5 class="text-center alert alert-warning">
                                {{ $t("SIGNERSMONITOR.noSignatoryRegistered") }}
                            </h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Popup para Alterar E-mails -->

        <div v-if="showEditEmailPopup" class="popup-overlay">
            <div class="popup-content">
                <h5>{{ $t("REGISTERSIGNERS.signatoriesTitle") }}</h5>
                <div v-show="errorMessage && signatories.length > 0"
                     class="medium mb-2 text-danger text-right bold">
                    {{ errorMessage }}
                </div>
                <ul class="list-group">
                    <li v-for="(signatory, index) in signatories" :key="signatory.emailBefore"
                        class="list-group-item d-flex justify-content-between align-items-center">
                        <div class="form-group mr-2 w-50">
                            <label>{{ $t("SIGNERSMONITOR.oldEmail") }}</label>
                            <input type="email" :value="signatory.emailBefore" disabled
                                   class="form-control mr-2"
                                   :placeholder="$t('SIGNERSMONITOR.oldEmail')" />
                        </div>
                        <div class="form-group mr-2 w-50">
                            <label>{{ $t("SIGNERSMONITOR.newEmail") }}</label>
                            <input type="email" v-model="signatories[index].emailAfter"
                                   :disabled="!signatory.isEditable"
                                   :class="{'is-invalid': signatory.hasError}" class="form-control mr-2"
                                   :placeholder="$t('SIGNERSMONITOR.placeholder')"
                                   @blur="isValidEmail(index)" />
                        </div>
                        <div class="form-group mr-2 mt-2 pt-4">
                            <button type="button" class="btn btn-secondary btn-sm"
                                    v-on:click="enableEditing(index)">
                                {{ $t("SIGNERSMONITOR.alter") }}
                            </button>
                        </div>
                    </li>
                </ul>
                <div class="text-right mt-3">
                    <button type="button" class="btn btn-secondary btn-mobile mr-3" @click="cancelEmail">{{ $t("REGISTERSIGNERS.cancel") }}</button>
                    <button v-if="signatories.length > 0" type="button" class="btn btn-primary" @click="changeEmails">{{ $t("REGISTERSIGNERS.edit") }}</button>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import SharedMixin from "../mixins/SharedMethods.js";
import StatusEnvelope from "../shared/statusEnvelope.js";
import PlatformUids from "../shared/platformUids.js";

export default {
    name: "SignersMonitor",
    mixins: [SharedMixin],
    props: {
        el: String,
        zeevUrl: String,
        token: String,
        instanceId: String,
        taskId: String,
        signPlatformUid: String,
        userExecuteId: String,
        userExecuteOriginalId: String,
        envelopeUid: String,
        apiUrl: String,
        envelopeStatusId: String,
        language: String,
        assignmentId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            load: {
                isLoading: true,
                msg: this.$t("SIGNERSMONITOR.wait"),
            },
            error: {
                isError: false,
                msg: "",
            },
            signers: [],
            urlCallBack: window.location.href,
            stsEnvelope: StatusEnvelope,
            platformUids: PlatformUids,
            showEditEmailPopup: false,
            signatories: [],
            envelopes: [],
            errorMessage: "",
            selectedEnvelopeUid: "",
            allEnvelopesConcluded: false
        };
    },
    computed: {
        isEnvelopeConcluded: function () {
            return (
                this.envelopes.every(envelope =>
                    envelope.statusId === StatusEnvelope.Completed ||
                    envelope.statusId === StatusEnvelope.Canceled ||
                    envelope.statusId === StatusEnvelope.Declined)
                );
            },
    },
        created() {
            this.setLanguage(this.language);
            this.updateInfo();
    },
        methods: {
        updateInfo: function () {
            if (this.signPlatformUid === this.platformUids.D4Sign) {
                this.getListEnvelope();
            }
            else
                this.getEnvelope();
        },
        editEnvelope: function (envelope) {
            switch (this.signPlatformUid) {
                case this.platformUids.D4Sign:
                    this.showEditEmailPopup = true;
                    this.signatories = envelope.signers.map(signer => ({
                        emailBefore: signer.email,
                        emailAfter: '',
                        hasError: false,
                        isEditable: false
                    }));
                    this.selectedEnvelopeUid = envelope.envelopeUid;
                    break;
                case this.platformUids.DocuSign:
                case this.platformUids.DocuSignDemo:
                    this.getEnvelopeUrl();
                    break;
                default:
                    console.log('ID da plataforma não informada ou inválida.');
                    break;
            }
        },
        getEnvelope: function () {
            this.error.isError = false;
            this.load.isLoading = true;

            const { url, requestOptions } = this.getRequestOptions("GET", `/api/internal/v1/envelope/${this.envelopeUid}`);

            fetch(url, requestOptions)
                .then((response) => response.json())
                .then((envelope) => {
                    this.envelopes = [{
                        signers: envelope.signers,
                        status: envelope.status,
                        statusId: envelope.statusId,
                        envelopeUid: this.envelopeUid
                    }];
                    this.showFinishTaskButton(this.isEnvelopeConcluded);
                })
                .catch((err) => {
                    this.error.isError = true;
                    this.error.msg = err;
                })
                .then(() => {
                    this.load.isLoading = false;
                });
        },
        getListEnvelope: function () {
            this.error.isError = false;
            this.load.isLoading = true;

            const { url, requestOptions } = this.getRequestOptions("GET", `/api/internal/v1/envelope/${this.instanceId}/${this.taskId}/${this.assignmentId}`);

            fetch(url, requestOptions)
                .then((response) => response.json())
                .then((envelopes) => {
                    this.envelopes = envelopes;
                    this.allEnvelopesConcluded = envelopes.every(envelope =>
                        envelope.statusId === StatusEnvelope.Completed ||
                        envelope.statusId === StatusEnvelope.Canceled ||
                        envelope.statusId === StatusEnvelope.Declined
                    );
                    this.showFinishTaskButton(this.allEnvelopesConcluded);
                })
                .catch((err) => {
                    this.error.isError = true;
                    this.error.msg = err;
                })
                .then(() => {
                    this.load.isLoading = false;
                });
        },
        getEnvelopeUrl: function () {
            this.error.isError = false;
            this.load.isLoading = true;

            const { url, requestOptions } = this.getRequestOptions(
                "GET",
                `/api/services/v1/envelopes/correct/${this.signPlatformUid}/${this.envelopeUid}?urlCallBack=${this.urlCallBack}`
            );

            fetch(url, requestOptions)
                .then((response) => response.json())
                .then((response) => {
                    if (!response.success) {
                        this.error.isError = true;
                        this.error.msg = response.message;
                        return;
                    }

                    if (response.isEnvelopeConcluded) {
                        this.getEnvelope();
                    } else {
                        this.openEditEnvelopeWindow(response.urlViewEnvelope)
                    }
                })
                .catch((err) => {
                    this.error.isError = true;
                    this.error.msg = err;
                })
                .then(() => {
                    this.load.isLoading = false;
                });
        },
        openEditEnvelopeWindow: function (url) {
            var win = window.open(url, '_blank');

            if (win) {
                win.focus();
            } else {
                this.error.isError = true;
                this.error.msg = this.$t("SIGNERSMONITOR.popupWarning");
            }
            },
        changeEmails: function () {
            this.load.isLoading = true;

            if (this.validateEmail()) {
                this.load.isLoading = false;
                return;
            }
                
            this.signatories = this.signatories.filter(signatory => signatory.emailAfter.trim() !== '');

            if (this.signatories.length === 0) {
                this.errorMessage = this.$t("REGISTERSIGNERS.noSignatoriesWithNewEmail");
                this.cancelEmail();
                this.load.isLoading = false;
                return;
            }

            this.updateEmails();
        },
        updateEmails: function () {
            this.error.isError = false;
            this.showEditEmailPopup = false

            let requestBody = {
                EnvelopeId: this.selectedEnvelopeUid,
                SignerEmails: this.signatories
            };

            const { url, requestOptions } = this.getRequestOptions(
                "POST",
                "/api/services/v1/envelopes/updateSigners",
                requestBody
            );

            fetch(url, requestOptions)
                .then((response) => response.json())
                .then((response) => {
                    if (response.success) {
                        this.getListEnvelope();
                    } else {
                        this.handleErrors(response);
                    }
                })
                .catch((err) => {
                    this.error.isError = true;
                    this.error.msg = err;
                })
                .then(() => {
                    this.load.isLoading = false;
                });
        },
        validateEmail: function () {
            this.errorMessage = "";
            let hasInvalidEmail = false;

            if (this.signatories.length === 0) {
                this.errorMessage = this.$t("REGISTERSIGNERS.noSignatories");
                return;
            }

            this.signatories = this.signatories.filter((signatory, index) => {
                if (!this.isValidEmail(signatory.emailAfter)) {
                    this.$set(this.signatories[index], 'hasError', true);
                    hasInvalidEmail = true;
                } else {
                    this.$set(this.signatories[index], 'hasError', false);
                }
                return true;
            });

            if (hasInvalidEmail) {
                this.errorMessage = this.$t("REGISTERSIGNERS.invalidEmail");
                return true;
            } else {
                return false;
            }
        },
        isValidEmail(email) {
            if (email.length === 0)
                return true;
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(email);
        },
        cancelEmail() {
            this.errorMessage = "";
            this.signers = [],
            this.signatories = [];
            this.showEmailPopup = false;
            this.selectedEnvelopeUid = "";
            this.showEditEmailPopup = false
            },
        enableEditing(index) {
            this.$set(this.signatories[index], 'isEditable', true);
            },
        handleErrors: function (response) {
            var content = JSON.parse(response.content);
            if (content.errorCode)
                switch (content.errorCode) {
                    case "UNABLE_TO_CONVERT_DOCUMENT":
                        window.bsml.toast(
                            this.$t(
                                "DOCUMENTS.errors.unableToConvertDocument"
                            ) + content.errorCode,
                            "alert-warning"
                        );
                        break;
                    case "USER_LACKS_PERMISSIONS":
                        window.bsml.toast(
                            this.$t("DOCUMENTS.errors.userLackPermissions") +
                            content.errorCode,
                            "alert-warning"
                        );
                        break;

                    default:
                        window.bsml.toast(
                            this.$t("DOCUMENTS.errors.default") +
                            content.errorCode,
                            "alert-warning"
                        );
                        break;
                }

            if (content.error)
                switch (content.error) {
                    case "invalid_grant":
                        window.bsml.toast(
                            this.$t("DOCUMENTS.errors.default") + content.error,
                            "alert-warning"
                        );

                        break;

                    default:
                        window.bsml.toast(
                            this.$t("DOCUMENTS.errors.defaultError") + content.error,
                            "alert-warning"
                        );
                        break;
                }
            if (content.mensagem_pt) {
                window.bsml.toast(
                    this.$t("DOCUMENTS.errors.defaultError") + content.mensagem_pt,
                    "alert-warning"
                );
            }
        },
        getRequestOptions: function (method, endpoint, body = null) {
            let url = `${this.apiUrl}${endpoint}`;
            let token = btoa(`${this.zeevUrl};${this.token}`);

            var headers = new Headers();
            headers.append("Authorization", `Bearer ${token}`);
            headers.append("Accept-Language", this.language);

            if (["POST", "PUT", "PATCH"].includes(method))
                headers.append("Content-Type", "application/json");

            var requestOptions = {
                method: method,
                headers: headers
            };

            if (body)
                requestOptions.body = JSON.stringify(body);

            return { url, requestOptions };
        }
    },
};
</script>

<style scoped>

.button-align {
    text-align: right;
}

.button-update {
    position: relative;
    top: -23px;
}

.h5 {
    display: inline-block;
    margin-right: 10px;
}

 .popup-overlay {
     position: fixed;
     top: 0;
     left: 0;
     width: 100%;
     height: 100%;
     background-color: rgba(0, 0, 0, 0.5);
     display: flex;
     justify-content: center;
     align-items: center;
     z-index: 1000;
 }

 .popup-content {
     background-color: #fff;
     padding: 20px;
     border-radius: 5px;
     width: 900px !important;
     box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
 }
</style>
